module.exports = global["jQuery"] = require("-!D:\\WangJieWork\\项目\\卓尤\\webInit\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");